import { CssBaseline, Grid } from '@mui/material'

import React from 'react'

type Props = {
  children: React.ReactNode
  className?: string
}

const Layout = ({ children, className }: Props): JSX.Element => {
  return (
    <div className={`PublicLoanContainer-mainLayout ${className ? className : ''}`}>
      <CssBaseline />
      <Grid container className="Layout-MainContainer">
        <Grid item xs={12} className="Layout-MainContainer-MainContent">
          {children}
        </Grid>
      </Grid>
    </div>
  )
}

export default Layout
